import { createFileRoute } from '@tanstack/react-router'
import { internshipSearchSchema } from '@/entities/internship/model/internshipSearch'
import { InternshipsPage } from '@/pages/internships/ui/InternshipsPage'

export const Route = createFileRoute('/internships')({
  validateSearch: internshipSearchSchema,
  component: InternshipsPage,
})
